import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Outlet } from 'react-router-dom';

function App() {
  return (
    <div style={{ margin: '1rem' }}>
      <header>
        <h1>Saoodi-App</h1>
      </header>
      <Outlet />
    </div>
  );
}

export default App;
